import * as React from 'react';

import { translate } from '~l10n/client';

import { IconButton } from '~shared/components/buttons';
import { IconRestore, IconTrash } from '~shared/components/icons/standard';
import { Inline } from '~shared/components/Inline';
import { TooltipV2 } from '~shared/components/TooltipV2';

interface QuizTrashActionProps {
  openPurgeDialog: () => void;
  restoreSelected: () => void;
  selectedQuizItems: Set<string>;
}

export function QuizTrashActions({
  restoreSelected,
  openPurgeDialog,
  selectedQuizItems,
}: QuizTrashActionProps) {
  const isLessThanOneItemSelected = selectedQuizItems.size < 1;
  return (
    <Inline>
      {!isLessThanOneItemSelected ? (
        <>
          <TooltipV2 label={translate('Delete Forever')}>
            <IconButton
              appearance="default"
              aria-label={translate('Delete Forever')}
              disabled={isLessThanOneItemSelected}
              onClick={openPurgeDialog}
            >
              <IconTrash />
            </IconButton>
          </TooltipV2>
          <TooltipV2 label={translate('Restore')}>
            <IconButton
              appearance="default"
              aria-label={translate('Restore')}
              disabled={isLessThanOneItemSelected}
              onClick={restoreSelected}
            >
              <IconRestore />
            </IconButton>
          </TooltipV2>
        </>
      ) : (
        <></>
      )}
    </Inline>
  );
}
